// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 63 ? "ImportFuncDemo" : chunkId) + "." + {"63":"c3da9bda","437":"b63fcfb2"}[chunkId] + ".js";
};